import product from './product'
import ModalApp from './ModalApp'
import Cart from './cart'
import Auth from './auth'
import {  ThemeProvider } from "vue-styled-components"
import { Carousel, Slide } from 'vue-carousel'
import Styled from './Styles'
import CarouselBanner from './carousel'
import Footer from './footer'
import Header from './header'
import Checkout from './checkout'
import Payment from './payment'
import Newsletter from './Newsletter'
import CookiesConsent from './cookies-consent'
import WidgetTitleFilter from './WidgetTitleFilter'
import Video from './video'
import CardConfig from './cardConfig'
import PopUp from './popUp'
import Authenticated from '../components/mercado-livre'
import SidebarWrapper from './SidebarWrapper'
import Maps from './maps'
import Toast from './Toast.vue'
import ToastConfirm from './ToastConfirm.vue'
import SetData from './SetData.vue'
import Purchase from './purchase'
import ModalCarousel from './ModalCarousel'
import ModalGeolocation from './ModalGeolocation'

export default {
    ...product,
    ...Cart,
    ...Auth,
    ...Styled,
    ...CarouselBanner,
    ...Footer,
    ...Header,
    ...Checkout,
    ...Payment,
    ...CookiesConsent,
    ...Video,
    ...CardConfig,
    ...PopUp,
    ...Maps,
    ...Authenticated,
    ...Purchase,
    'modal-app': ModalApp,
    'theme-provider': ThemeProvider,
    'carousel-app': Carousel,
    'slide-app':Slide,
    'newsletter': Newsletter,
    'widget-title-filter': WidgetTitleFilter,
    'sidebar-wrapper': SidebarWrapper,
    'toast': Toast,
    'toast-confirm': ToastConfirm,
    'set-data': SetData,
    'modal-carousel': ModalCarousel,
    'modal-geolocation': ModalGeolocation,
}
